import { useTranslation } from 'react-i18next';

import { cookiesEnabled } from './utils';
import { InfoMessage } from '../../components/InfoMessage';

const NoCookies: React.FC<{}> = () => {
  const { t } = useTranslation();
  if (cookiesEnabled()) return null;
  return (
    <InfoMessage isError={true}>
      {t(
        'This application requires your browser to have cookies enabled. Change your privacy settings and refresh the page to login.',
      )}
    </InfoMessage>
  );
};

export default NoCookies;
